<dx-box height="100%" width="100%" direction="col" class="cc-white-background">
    <dxi-item baseSize="auto">
        <div *dxTemplate class="logo-container">
            <img [src]="ciraLogo" height="30" width="50" alt="CiraConnect" />
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <h2 class="page-heading cc-text-center dx-theme-border-color-as-background-color">
                {{ pageTitle }}
            </h2>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto" [visible]="!!action && !status">
        <div *dxTemplate class="action-container">
            <dx-form width="100%" height="100%" [colCount]="2" *ngIf="workQueueActionsDetailResult?.allowDeny">
                <dxi-item itemType="group">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Deny Reason" location="top"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area [height]="60" [(value)]="reason"></dx-text-area>
                        </div>
                    </dxi-item>
                    <dxi-item
                        itemType="button"
                        horizontalAlignment="right"
                        [buttonOptions]="{
                            type: 'default',
                            stylingMode: 'contained',
                            hint: 'Confirm Deny',
                            text: 'Confirm Deny',
                            icon: iconCross,
                            onClick: onSubmit
                        }"
                    ></dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto" [visible]="!!status">
        <div *dxTemplate class="status-container">
            <div class="error-container">
                <i *ngIf="status?.iconText === 'FLAG_RED'" [ngClass]="iconFlag" class="fa-2x cc-red-icon"></i>
                <i *ngIf="status?.iconText === 'ALERT'" [ngClass]="iconWarn" class="fa-2x cc-yellow-icon"></i>
                <i *ngIf="status?.iconText === 'SUCCESS'" [ngClass]="iconCheck" class="fa-2x cc-green-icon"></i>
                <h2>
                    <strong>{{ status?.statusHeader }}</strong>
                </h2>
            </div>

            <p class="top-padding">
                {{ status?.statusMsg }}
            </p>
        </div>
    </dxi-item>
</dx-box>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
